/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MinMaxRuleResource
 */
export interface MinMaxRuleResource {
    /**
     * 
     * @type {number}
     * @memberof MinMaxRuleResource
     */
    min: number;
    /**
     * 
     * @type {number}
     * @memberof MinMaxRuleResource
     */
    max: number;
}

/**
 * Check if a given object implements the MinMaxRuleResource interface.
 */
export function instanceOfMinMaxRuleResource(value: object): value is MinMaxRuleResource {
    if (!('min' in value) || value['min'] === undefined) return false;
    if (!('max' in value) || value['max'] === undefined) return false;
    return true;
}

export function MinMaxRuleResourceFromJSON(json: any): MinMaxRuleResource {
    return MinMaxRuleResourceFromJSONTyped(json, false);
}

export function MinMaxRuleResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinMaxRuleResource {
    if (json == null) {
        return json;
    }
    return {
        
        'min': json['min'],
        'max': json['max'],
    };
}

export function MinMaxRuleResourceToJSON(value?: MinMaxRuleResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'min': value['min'],
        'max': value['max'],
    };
}

